import React, { useMemo, useState } from "react";
import {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../designsystem/KC_Button/KC_Button";
import {
  faDownload,
  faImage,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import KC_Icon_Button from "../../../../designsystem/KC_Button/KC_Icon_Button";
import { setLoading } from "../../../../redux/actions/app";
import { POSATypeJavascriptDTO } from "@tootsweet/model/lottery/POSAType";
import { useDispatch } from "react-redux";
import KC_Button from "../../../../designsystem/KC_Button/KC_Button";
import { tt } from "../../../../utils/i18n/i18n";
import KC_Modal from "../../../../designsystem/KC_Modal/KC_Modal";
import CONFIG from "../../../../model/TSConfig";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";
import { buildPreviewLinkForNonCustomPOSA } from "../../../../utils/helpers/buildPreviewLinkForNonCustomPOSA";
import moment from "moment-timezone";
import { exportSVGToPNG } from "../../../../utils/svgRenderer";
import { ExportSVGToPDF } from "kadow-svg-utils";

interface Props {
  eventId: string;
  configId?: string;
  customURL?: string;
  posa: POSATypeJavascriptDTO;
}

const DownloadPOSAButton = (props: Props) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  const filename = useMemo(() => {
    return `${props.posa.format}-${props.posa.shortId}-${moment().format(tt("date_format_full_with_time"))}`;
  }, [props.posa]);

  const downloadPNG = async () => {
    try {
      if (!props.posa.isCustom && props.posa.isOnline) {
        const url = buildPreviewLinkForNonCustomPOSA(
          props.posa.ratio,
          props.posa.shortId,
          false,
          props.posa.isOnline
        );
        dispatch(setLoading(true));
        void exportSVGToPNG.downloadPngFromS3(url, filename);
        return;
      }

      if (!props.customURL) {
        alert(tt("error"));
        return;
      }

      dispatch(setLoading(true));
      void exportSVGToPNG.downloadPngFromS3(props.customURL, filename);
    } catch (error) {
      console.error("Failed to generate PNG:", error);
    } finally {
      dispatch(setLoading(false));
      setShowModal(false);
    }
  };

  const downloadPDF = async () => {
    try {
      dispatch(setLoading(true));

      const pngUrl = `${CONFIG.s3BucketURL}/${props.customURL}`;
      await ExportSVGToPDF.generateAndSavePDF(
        pngUrl,
        props.posa.format,
        `${filename}.pdf`
      );
    } catch (error) {
      console.error("Failed to generate PDF:", error);
    } finally {
      setShowModal(false);
      dispatch(setLoading(false));
    }
  };

  const isOnline = useMemo(() => {
    return (
      props.posa.format === "online-ig-post" ||
      props.posa.format === "online-ig-story"
    );
  }, [props.posa]);

  return (
    <>
      <KC_Icon_Button
        isPrimary={false}
        isInverted={true}
        size={KC_ButtonSize.Medium}
        onClick={() => setShowModal(true)}
        type={KC_ButtonType.Button}
        icon={faDownload}
      />

      <KC_Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        size="sm"
        header={
          <div className="w-100 py-2">
            <KC_Heading3
              className="text-center"
              text={tt("download_your_materials")}
            />
          </div>
        }
      >
        <div className="d-flex flex-column st-gap">
          {!isOnline && (
            <KC_UIText
              weight="reg"
              text={tt("download_posa_text")}
              className="text-center"
            />
          )}
          <KC_Button
            size={KC_ButtonSize.Medium}
            type={KC_ButtonType.Button}
            onClick={downloadPNG}
            isPrimary={true}
            text={tt("jetpack_config_download_png")}
            icon={faImage}
            showIconOnTheRight={true}
          />
          {!isOnline && (
            <KC_Button
              size={KC_ButtonSize.Medium}
              type={KC_ButtonType.Button}
              onClick={downloadPDF}
              isPrimary={true}
              text={tt("jetpack_config_download_pdf")}
              icon={faFilePdf}
              showIconOnTheRight={true}
            />
          )}
        </div>
      </KC_Modal>
    </>
  );
};

export default DownloadPOSAButton;
